import clsx from 'clsx';
import { memo } from 'react';

type Props = {
    fullSize?: boolean;
    idle?: boolean;
    className?: string;
    size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl';
}

export const SkeletonButton = memo(({ fullSize, idle, className, size = 'md' }: Props) => (
    <div className={clsx({
        'vss-skeleton-button': true,
        'vss-skeleton-button--idle': idle,
        'vss-skeleton-button--full-size': fullSize,
        [`vss-skeleton-button--${size}`]: true,
    }, className)}
    />
));
